import { CaseCard } from '@components/case_card.component';
import { Icon } from '@components/icon.component';
import { AttentionCardCaseCardWrapper } from './_attention_card_case_card_wrapper.component';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import type {
	AttentionCardAppointmentCaseModel,
	AttentionCardMessageCaseModel,
} from '@components/attention_card/_attention_card.controller';

interface Props {
	case: AttentionCardAppointmentCaseModel | AttentionCardMessageCaseModel;
	unansweredFormsNames: string[];
}

export function AttentionCardTypeUnansweredForms({ case: $case, unansweredFormsNames }: Props): JSX.Element {
	const isAppointment = $case.type === 'appointment';
	const [description, ariaLabel] = isAppointment
		? [
				withTranslation('PW.Component.AttentionCard.UnansweredForms.Description', { date: $case.dateFormatted }),
				withTranslation('PW.Component.AttentionCard.UnansweredForms.Aria', { date: $case.dateFormatted }),
		  ]
		: // TODO: PAT-373 this should have correct translations when it's a messaging case
		  ['', withTranslation('PW.Component.AttentionCard.UnansweredForms.Aria', { date: $case.dateFormatted })];

	return (
		<AttentionCardCaseCardWrapper
			alertiveTitle={isAppointment}
			to={$case.link}
			description={description}
			ariaLabel={ariaLabel}
			analyticAction='Clicked Unanswered forms-card'
		>
			<CaseCard>
				<CaseCard.Thumbnail size={30} type='neutral'>
					<Icon type='form' />
				</CaseCard.Thumbnail>
				<CaseCard.Title>{withTranslation('PW.Component.AttentionCard.UnansweredForms.Subject')}</CaseCard.Title>
				<CaseCard.Subtitle>{unansweredFormsNames.join(', ')}</CaseCard.Subtitle>
				<CaseCard.Icon>
					<Icon type='attentionCardArrow' />
				</CaseCard.Icon>
			</CaseCard>
		</AttentionCardCaseCardWrapper>
	);
}
